const API_MAINTENANCE = "https://interni.sacelman.it/API/customerMaintenance";
// const API_DEMO_REQUESTS = "http://localhost:81/API/simplemanDemoRequests";
const API_DEMO_REQUESTS =
  "https://interni.sacelman.it/API/simplemanDemoRequests";
const API_VIDEOS = "https://interni.sacelman.it/API/tutorialVideos";

// const API_MAINTENANCE = "http://localhost:81/API/customerMaintenance";

const mainProvider = {
  call: async num => {
    const request = new Request(`${API_MAINTENANCE}/callFromWeb`, {
      method: "POST",
      body: JSON.stringify({ phone: num }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Sacel-Shared-Key": "S4c3lM0b1leApPK3y..10",
      },
    });

    const response = await fetch(request);
    const data = await response.json();

    let error = "Ci sono stati problemi con la chiamata, prova più tardi";

    if (data.params === "STATUS_LIMIT_REACHED") {
      error = "Numero massimo di chiamate giornaliere raggiunto.";
    } else if (response.status === 200) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(error));
  },

  saveForm: async form => {
    const request = new Request(`${API_DEMO_REQUESTS}/saveForm`, {
      method: "POST",
      body: JSON.stringify({ form: form }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Sacel-Shared-Key": "S4c3lM0b1leApPK3y..10",
      },
    });

    const response = await fetch(request);
    if (response.status === 200) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error(
        "Ci sono stati problemi con il salvataggio del form, riprova più tardi"
      )
    );
  },

  getTutorialVideo: async () => {
    const request = new Request(`${API_VIDEOS}/loadVideo`, {
      method: "POST",
      body: JSON.stringify({ filters: { type: "maintenance" } }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Sacel-Shared-Key": "S4c3lM0b1leApPK3y..10",
      },
    });

    const response = await fetch(request);
    const data = await response.json();

    if (response.status === 200) {
      return Promise.resolve({ videos: data.params });
    }
    return Promise.reject(
      new Error("Ci sono stati problemi con il reperimento dei video")
    );
  },
};

export default mainProvider;
